import React, { useState } from "react";
import { AddOutlined, PersonAddOutlined } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { WithTooltip } from "@components";
import locale from "@bonliva-crm/locale";
import { store } from "@store";
import {
  BookingKitSearchItemFragment,
  BookingKitAssignedFragment,
  useAssignToBookingKitMutation,
  useUnAssignFromBookingKitMutation
} from "@graphql";
import Avatar from "@common/Avatar";
import { useDialog } from "@hooks";

export type AssignToKitDialogData = { onSelect: (userId: string) => Promise<any> };

type Props = {
  data: BookingKitSearchItemFragment;
  dialog: ReturnType<typeof useDialog<AssignToKitDialogData>>;
};

type AssignedType = {
  assignedByUserName: string;
  assignedByUserId: string;
  assignedOn: Date;
  assignedToUserName: string;
  assignedToUserId: string;
};

export const AssignToKitCol = ({ data, dialog }: Props) => {
  const [assign, { loading }] = useAssignToBookingKitMutation();
  const [unAssign] = useUnAssignFromBookingKitMutation();

  const [item] = useState<AssignedType | null>(getAssigned(data) ?? null);
  const userId = store().user.id;
  const kitId = data?._id;
  const handleAssign = async (userId) => {
    try {
      assign({ variables: { userId, kitId } }).then((res) => {
        if (res.errors) {
          store().snackbars.error(res.errors.join(", "));
        }

        window.dispatchEvent(new Event("forcepoll"));
      });
    } catch (e) {
      store().snackbars.error(e);
    }
  };

  const handleUnAssign = async (userId: string) => {
    try {
      store().ui.confirmDelete(`${locale.Un_Assign}`, (confirmed) => {
        if (!confirmed) {
          return;
        }
        unAssign({ variables: { userId, kitId } }).then((res) => {
          if (res.errors) {
            store().snackbars.error(res.errors.join(", "));
          }

          window.dispatchEvent(new Event("forcepoll"));
        });
      });
    } catch (e) {
      store().snackbars.error(e);
    }
  };

  return (
    <div key={data?._id} onClick={(e) => e.preventDefault()}>
      {!item?.assignedToUserId && (
        <>
          <IconButton
            disabled={loading}
            size={"small"}
            onClick={() => handleAssign(userId)}
          >
            <AddOutlined />
          </IconButton>
          <IconButton
            size={"small"}
            disabled={loading}
            onClick={() => dialog.onOpen({ onSelect: handleAssign })}
          >
            <PersonAddOutlined />
          </IconButton>
        </>
      )}

      {item?.assignedToUserId && (
        <WithTooltip title={item.assignedToUserName} key={item.assignedByUserId}>
          <span>
            <Avatar
              onClick={() => handleUnAssign(item.assignedToUserId)}
              size={"small"}
              name={item.assignedToUserName}
              src={""}
            />
          </span>
        </WithTooltip>
      )}
    </div>
  );
};

function getAssigned(data: BookingKitAssignedFragment): AssignedType | null {
  let assigned: AssignedType = null;
  if (data) {
    const {
      assignedByUserName,
      assignedByUserId,
      assignedOn,
      assignedToUserName,
      assignedToUserId
    } = data;

    assigned = {
      assignedByUserName,
      assignedByUserId,
      assignedOn,
      assignedToUserName,
      assignedToUserId
    };
  }
  return assigned;
}
